import { _ as _asyncToGenerator, r as regenerator } from '../index-e4593f56.js';
import { get, getApiUrl } from '../httpService/index.js';

var fetchExternalPromoUrl = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee(_ref) {
    var name;
    return regenerator.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          name = _ref.name;
          return _context.abrupt("return", get("".concat(getApiUrl(), "/shop/subscription/external/promo/url?name=").concat(name)));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchExternalPromoUrl(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var externalPromoService = {
  fetchExternalPromoUrl: fetchExternalPromoUrl
};

export { externalPromoService as default, fetchExternalPromoUrl };
//# sourceMappingURL=index.js.map
